export default __webpack_public_path__ + "static/media/box-important.db3814c2.png";